var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03516 2.08594L2.66016 5.2526V16.3359C2.66016 16.7559 2.82697 17.1586 3.1239 17.4555C3.42084 17.7525 3.82356 17.9193 4.24349 17.9193H15.3268C15.7467 17.9193 16.1495 17.7525 16.4464 17.4555C16.7433 17.1586 16.9102 16.7559 16.9102 16.3359V5.2526L14.5352 2.08594H5.03516Z",
    stroke: "white",
    strokeWidth: 1.38542,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66016 5.25H16.9102",
    stroke: "white",
    strokeWidth: 1.38542,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9525 8.41406C12.9525 9.25391 12.6188 10.0594 12.025 10.6532C11.4311 11.2471 10.6257 11.5807 9.78581 11.5807C8.94596 11.5807 8.1405 11.2471 7.54664 10.6532C6.95277 10.0594 6.61914 9.25391 6.61914 8.41406",
    stroke: "white",
    strokeWidth: 1.38542,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/BagIcon.0e724a3d2b9caee09cab04787bdbd9a6.svg";
export { ForwardRef as ReactComponent };